import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../../constants/constants';
import { resetInvoiceLine } from '../../../reducers/invoiceLineReducer';
import InvoiceLineForm from './invoiceLineForm';

interface IAddInvoiceLineProps {
    classes: any;
    theme: Theme;
    match: any;
    resetInvoiceLine: any;
    steps: Array<number>;
    invoiceLineId?: number;
    productId?: number;
    invoiceId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetInvoiceLine: () => dispatch(resetInvoiceLine())
});

const mapStoreToProps = (store: RootState, ownProps: IAddInvoiceLineProps) => {
    return {
        invoiceLineId: ownProps.match.params?.invoiceLineId ? Number(ownProps.match.params?.invoiceLineId) : undefined,
        invoiceId: ownProps.match.params?.invoiceId ? Number(ownProps.match.params?.invoiceId) : undefined,
        productId: ownProps.match.params?.productId ? Number(ownProps.match.params?.productId) : undefined
    };
};

class AddInvoiceLine extends Component<IAddInvoiceLineProps> {
    componentWillUnmount() {
        const { resetInvoiceLine } = this.props;

        resetInvoiceLine();
    }

    render() {
        const { classes, steps, invoiceLineId, type, invoiceId, productId } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <InvoiceLineForm invoiceLineId={invoiceLineId} steps={steps} type={type} invoiceId={invoiceId} productId={productId} />
                </CardContent>
            </Card>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddInvoiceLine));